import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=ab13ab5e"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports